import React from "react";

type ProviderCmp = React.ComponentType<React.PropsWithChildren>;

const forceMock = process.env.REACT_APP_USE_MOCK_AUTH === "true";
const isLocal =
  typeof window !== "undefined" &&
  ["localhost", "127.0.0.1", "::1"].includes(window.location.hostname);

let InnerProvider: ProviderCmp;

if (forceMock && isLocal) {
  // Only bundled when the condition is true at build time
  const mod = require("./MockAuthProvider");
  InnerProvider = mod.default || mod.MockAuthProvider;
} else {
  const mod = require("./KeycloakProvider");
  InnerProvider = mod.default || mod.KeycloakProvider;

  // Optional hard guard: fail fast if someone enables mock in prod
  if (process.env.NODE_ENV === "production" && forceMock && !isLocal) {
    // throw new Error("Mock auth is not allowed in production hosts");
    console.warn("Mock auth flag set, but disabled on non-local hosts.");
  }
}

export default function AuthProvider({ children }: React.PropsWithChildren) {
  return <InnerProvider>{children}</InnerProvider>;
}
